const TextSpacing = () => {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="96" height="96" rx="48" />
      <path
        d="M27.5859 30.4997L27.5859 25.0413C27.5859 21.5922 29.621 18.833 32.1157 18.833L63.8897 18.833C66.4062 18.833 68.4194 21.6222 68.4194 25.0413L68.4194 30.4997"
        stroke="black"
        strokeWidth="5.25002"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48 53.8335L48 21.75"
        stroke="black"
        strokeWidth="5.25002"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.3359 56.75L59.3194 56.75"
        stroke="black"
        strokeWidth="5.25002"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.6641 71.3345L74.2476 71.3345"
        stroke="black"
        strokeWidth="5.25002"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.5834 65.5008L21.75 71.3341L27.5834 77.1675"
        stroke="black"
        strokeWidth="5.25002"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M68.4141 65.5008L74.2474 71.3341L68.4141 77.1675"
        stroke="black"
        strokeWidth="5.25002"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TextSpacing;
